import { useEffect, useState } from 'react';
import { Button, ButtonTheme } from '@apply/components';
import { CustomPaymentStep } from '../../../../../constants/CustomPaymentStep';
import { useCustomPaymentCardNumber, useCustomPaymentCardType } from '../../../../../fields/CustomPaymentFields';
import { useSubmitCustomPayment } from '../../../../../hooks/useSubmitCustomPayment';
import { logApplicationInsightsError } from '../../../../../../common/functions/applicationInsightFunctions';

interface SubmitPaymentButtonProps {
    customPaymentId: string;
    paymentAgreementAccepted: boolean;
    notSupportedCardType: boolean;
    set_paymentStep: React.Dispatch<React.SetStateAction<CustomPaymentStep>>;
    errorMessage: string | undefined;
    set_errorMessage: React.Dispatch<React.SetStateAction<string | undefined>>;
}

export const SubmitPaymentButton: React.FC<SubmitPaymentButtonProps> = ({
    customPaymentId,
    paymentAgreementAccepted,
    notSupportedCardType,
    set_paymentStep,
    errorMessage,
    set_errorMessage,
}) => {
    const [cardType] = useCustomPaymentCardType(customPaymentId);
    const [cardNumber] = useCustomPaymentCardNumber(customPaymentId);
    const [processing, set_processing] = useState<boolean>(false);
    const submitPayment = useSubmitCustomPayment(customPaymentId);

    // Bubble errorMessage → Application Insights
    useEffect(() => {
        if (errorMessage) {
            logApplicationInsightsError(new Error(errorMessage));
        }
    }, [errorMessage]);

    const handleSubmit = () => {
        set_processing(true);
        submitPayment.mutate(undefined, {
            onSuccess: () => {
                set_processing(false);
                set_errorMessage(undefined);
                set_paymentStep(CustomPaymentStep.Finished);
                window.scrollTo(0, 0);
            },
            onError: (err: any) => {
                set_processing(false);
                set_errorMessage(err.message);
            },
        });
    };

    return (
        <>
            <Button
                id='customPaymentSubmitButton'
                theme={ButtonTheme.Primary}
                width='160px'
                type='button'
                handleClick={handleSubmit}
                disabled={
                    processing ||
                    !paymentAgreementAccepted ||
                    (cardNumber?.length != undefined && cardNumber.length < 16) ||
                    (notSupportedCardType && cardType != undefined)
                }
            >
                <span id='button-text'>
                    {processing ? (
                        <div
                            className='spinner spinner-small'
                            id='spinner'
                        ></div>
                    ) : (
                        'Pay now'
                    )}
                </span>
            </Button>
        </>
    );
};
